/**
 * Web Form for Marketers utilities
 * @namespace
 */
module YVR.WFFM {
	let currentForm: JQuery;

	const CSS_CLASSES_TO_COPY = [
		'halfAvailableWidth',
		'thirdAvailableWidth',
		'yvr-wffm__new-line'
	];


	function init() {
		initCssClassesForFormGroups();
		initRecaptcha();
	}


	function initCssClassesForFormGroups(selector = '.yvr-wffm input, .yvr-wffm select') {
		const inputs = $(selector);

		inputs.each((index, elem) => {
			const input = $(elem);

			CSS_CLASSES_TO_COPY.forEach(cssClass => {
				if (input.hasClass(cssClass)) {
					input.closest('.form-group').addClass(cssClass);
				}
			});
		});
	}


	function initRecaptcha(selector = '.yvr-wffm .g-recaptcha') {
		const recaptchas = $(selector);

		recaptchas.each((index, elem) => {
			const recaptcha = $(elem);

			recaptcha.siblings('label').hide();
		});
	}


	// Kick it
	init();
}
